import { useRef } from 'react';
import { IIndividual } from '../../../types/individual';
import { IOrg } from '../../../types/org';
import { IPosition } from '../../../types/position';
import Tabs, { Tab } from '../../common/tabs/tabs';
import Preview, { PreviewHandler } from '../../org/infogo-config/infogo-preview/preview';
import { Card, CardBody, CardTitle } from "reactstrap";
import SearchPositionPositionsRoles from './search-position-positions-roles';

type SearchPositionOrgInfoProps = {
  org: IOrg;
  //onPositionSelect: (position: IPosition | undefined) => void;
  //onIndividualSelect: (individual: IIndividual, positionRole: IPosition) => void;
}

const SearchPositionOrgInfo = (props: SearchPositionOrgInfoProps) => {
  const { org } = props
  const tabs: Tab[] = [
    { title: 'Positions & Roles', content: <SearchPositionPositionsRoles org={org}  /> }
  ];

  const previewRef = useRef<PreviewHandler>(null)

  return (
    <>
      <Card aria-label="Organization Information">
        <CardBody>
          <CardTitle>
            Organization: {org?.orgName}
          </CardTitle>

          <Tabs tabs={tabs} />
        </CardBody>
      </Card>

      <Preview ref={previewRef} org={org}></Preview>
    </>
  )
}

export default SearchPositionOrgInfo
